import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=2bc89f73&scoped=true"
import script from "./Direct.vue?vue&type=script&lang=js"
export * from "./Direct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc89f73",
  null
  
)

export default component.exports